<template>
  <section class="wrapper">
    <div class="title">Пожалуйста, проверьте данные перед отправкой</div>
  </section>
</template>

<script>
export default {
  name: 'StepSign',
};
</script>

<style lang="scss" scoped>
.wrapper {
  padding-left: 12px;
  padding-right: 12px;
}

.title {
  display: inline-block;
  border: 1px solid #f0f0f0;
  padding: 12px;
  margin-bottom: 24px;
  font-size: 32px;
  color: $color-error;
}
</style>
